import React, { FunctionComponent } from "react";
import { Grid } from "@mui/material";
import { AInfoSection } from "@atiautomacao/ati-ui-library";
import { useAppSelector } from "../../../Config/Hooks";
import { FindTeleObjectBessReactQuery, TeleObjectBessData } from "../Powerplant/batteries/BatteryReactQuery";
import { buildBessInstantInfoCards } from "./BessInstantInfoUtils";

interface BessInstantInfoSectionProps {
    equipmentId: number;
}

// SGD-3735: 4 cards de Informações Instantâneas (Funcionamento, Potência, Tensão AC|DC, Corrente AC|DC).
// Reaproveita o endpoint bess-object-type (last value no Postgres) e o componente AInfoSection (SGD-3661).
// Sem skeleton: os cards já exibem "-" enquanto o valor não chega, e o refresh usa refetch do react-query.
const BessInstantInfoSection: FunctionComponent<BessInstantInfoSectionProps> = ({ equipmentId }) => {
    const selectedPowerPlant = useAppSelector((state: any) => state.dashboard?.selectedPowerPlant);
    const powerStationId = Number(selectedPowerPlant?.id);
    const hasPowerStation = Number.isFinite(powerStationId) && powerStationId > 0;

    const query = FindTeleObjectBessReactQuery(equipmentId, hasPowerStation ? powerStationId : undefined);
    const bessData: TeleObjectBessData[] = query.data?.data ?? [];

    const cards = buildBessInstantInfoCards(bessData);

    return (
        <Grid container spacing={2}>
            {cards.map((card) => (
                <Grid item xs={12} sm={6} md={3} key={card.title}>
                    <AInfoSection title={card.title} items={card.items} />
                </Grid>
            ))}
        </Grid>
    );
};

export default BessInstantInfoSection;
